import "../../nuove-sezioni/fonts.scss";
import styles from "./Servizi.module.scss";
import { servizi as s } from "../../../types/content";
import { Icona, cx } from "../Icone";

const Servizi = () => {
  return (
    <div className={styles["servizi"]} id="servizi">
      <section className={styles["servizi__inner"]}>
        <div className={styles["servizi__head"]}>
          <h2 className={styles["servizi__h2"]}>
            {s.titolo} <em className={styles["servizi__serif"]}>{s.titoloCorsivo}</em>
          </h2>
          <p className={styles["servizi__intro"]}>{s.intro}</p>
        </div>
        <div className={styles["servizi__griglia"]}>
          {s.lista.map((v) => (
            <article
              key={v.titolo}
              className={cx(styles["servizi__card"], styles[`servizi__card--${v.stile}`])}
            >
              <div className={styles["servizi__top"]}>
                <span className={styles["servizi__num"]}>{v.numero}</span>
                <Icona nome={v.icona} />
              </div>
              <h3 className={styles["servizi__h3"]}>{v.titolo}</h3>
              <p className={styles["servizi__testo"]}>{v.testo}</p>
              <ul className={styles["servizi__tags"]}>
                {v.tag.map((t) => (
                  <li key={t}>{t}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Servizi;
